<template>
  <div class="postlist">
    <h2>Neueste Beiträge</h2>
    <div v-for="post in orderedPosts" v-bind:key="post['.key']" @click="open(post)" style="border-bottom: 1px solid #efefef; margin-bottom: 10px; padding-bottom: 10px;">
      <b style="color:#334274;">{{post.title}}</b><br />
      <span style="font-size:0.9em; opacity: 0.6;">{{post.created|formatDate}}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SidebarNewPosts',
  props: ['posts'],
  methods: {
    open (post) {
      this.$emit('open', post)
    }
  },
  computed: {
    orderedPosts: function () {
      return _.take(_.orderBy(this.posts, ['created'], ['desc']), 20)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  .postlist > div {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/SidebarNewPosts.vue